import { render, staticRenderFns } from "./ServiceAgreementEN.vue?vue&type=template&id=4fcee596&scoped=true&"
import script from "./ServiceAgreementEN.vue?vue&type=script&lang=js&"
export * from "./ServiceAgreementEN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcee596",
  null
  
)

export default component.exports